import {Component, OnInit, AfterViewInit, ViewChild, OnDestroy} from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { NegociosService, FUENTE_NAMES } from '@services/negocios-service';

import {
  CuentaAutocompleteComponent,
  ColaboradorAutocompleteComponent,
  AcopioAutocompleteComponent
} from '@common/autocomplete';

import * as moment from 'moment';
import { MonedaService, MONEDA_PESIFICACION } from '@services/moneda-service';
import { PosicionService, EntregaService } from '@services/index';
import { ProductoService } from '@services/producto-service';
import { CosechaService } from '@services/cosecha-service';
import { CategoriaService } from '@services/categoria-service';
import { PreciosService } from '@services/precios-service';
import {Subject} from 'rxjs/Subject';


@Component({
  selector: 'filters-negocios-dialog-component',
  templateUrl: './filters-negocios-dialog.component.html',
  styleUrls: ['./filters-negocios-dialog.component.scss']
})
export class FiltersNegociosDialogComponent implements OnInit, AfterViewInit, OnDestroy {

  public title: string;
  public column: string;
  public filters = {};

  forwardNegocioID;
  entregaOptions = [];
  cosechaOptions = [];
  confirmacionOptions = [];
  tipoOptions = [];
  productoOptions = [];
  negocioOptions = [];
  monedaOptions = [];
  mercadosOptions = [];

  confirmacionOptionsByTipo = {};

  tmpConfirmacion;

  categoriaOptions = [];
  tmpCategoria;

  tmpTipo;

  errors;
  MONEDA_PESIFICACION = MONEDA_PESIFICACION;
  @ViewChild('startDatePicker') startDatePicker;
  @ViewChild('endDatePicker') endDatePicker;

  @ViewChild(CuentaAutocompleteComponent) cuentaAutocompleteComponent;
  @ViewChild(ColaboradorAutocompleteComponent) colaboradorAutocompleteComponent;
  @ViewChild(AcopioAutocompleteComponent) acopioAutocompleteComponent;

  FUENTE_NAMES = FUENTE_NAMES;

  destroyedSubject = new Subject();

  constructor(public dialogRef: MdDialogRef<FiltersNegociosDialogComponent>,
              private negociosService: NegociosService,
              private entregaService: EntregaService,
              private monedaService: MonedaService,
              private posicionService: PosicionService,
              private productoService: ProductoService,
              private cosechaService: CosechaService,
              private  categoriaService: CategoriaService,
              private preciosService: PreciosService) {
    monedaService.Options.takeUntil(this.destroyedSubject).subscribe(newValue => {
      if (newValue.length) {
        this.monedaOptions = [...newValue, this.MONEDA_PESIFICACION];
      }
    });
    productoService.Options.takeUntil(this.destroyedSubject).subscribe(newValue => {
      this.productoOptions = newValue;
    });
    cosechaService.Options.takeUntil(this.destroyedSubject).subscribe(newValue => {
      this.cosechaOptions = newValue.sort(function (a, b) { return b.Desde - a.Desde });
    });
    entregaService.ForwardNegocioID.takeUntil(this.destroyedSubject).subscribe(newValue => {
      this.forwardNegocioID = newValue;
    });
    entregaService.PosicionOptions.takeUntil(this.destroyedSubject).subscribe(newValue => {
      this.entregaOptions = newValue;
    });
    categoriaService.Options.takeUntil(this.destroyedSubject).subscribe(newValue => {
      this.categoriaOptions = newValue;
      this.checkZonaOptions();
    });
    this.preciosService.getMercadosPizarra().take(1).subscribe(x => {
      this.mercadosOptions = x.filter(y => y.Visibilidad);
    });
  }

  ngOnDestroy() {
    this.destroyedSubject.next();
  }

  ngOnInit() {
    this.posicionService.loadOptions();
    this.confirmacionOptionsByTipo = this.negociosService.getConfirmacionOptionsByTipo();
    this.categoriaService.loadOptions();

    // Copiar datos e inicializar modelos
    const dateColumns = ['fecha', 'hora', 'vencimiento', 'fecha-estado'];
    if (dateColumns.includes(this.column)) {
      if (!this.filters[this.column]) {
        this.filters[this.column] = {
          startDate: moment().subtract(15, 'days').toDate(),
          endDate: moment().toDate()
        };
      } else {
        this.filters[this.column] = {
          startDate: moment(this.filters[this.column].startDate).toDate(),
          endDate: moment(this.filters[this.column].endDate).toDate()
        };
      }
      // traduccion, si el filtro elegido no es ninguno de los que esta ahi abajo
    } else if (['cliente', 'responsable', 'acopio', 'confirmación', 'zona', 'tipo'].indexOf(this.column) < 0) {
      if (!this.filters[this.column]) {
        this.filters[this.column] = { model1: null, model2: null };
      }
    } else if (this.column === 'confirmación') {
      this.filters['confirmación'] = this.filters['confirmación'] || [];
    } else if (this.column === 'zona') {
      this.filters['zona'] = this.filters['zona'] || [];
    } else if (this.column === 'tipo') {
      this.filters['tipo'] = this.filters['tipo'] || [];
    }

    this.tipoOptions = this.negociosService.getTipoSelectOptions();
    this.negocioOptions = this.negociosService.getNegocioSelectOptions().slice(0, 3);    // sacamos basis por ahora

    // Select de confirmación
    if (this.filters['tipo'] && this.filters['tipo'].model1) {
      this.confirmacionOptions = this.confirmacionOptionsByTipo[this.filters['tipo'].model1];
    } else {
      this.confirmacionOptions = this.negociosService.getConfirmacionOptions();
    }

    if (this.column === 'confirmación') {

      if (this.filters['tipo']) {
        // primero generamos un array de estados con los estados posibles para los filtros elegidos
        let estados = [];
        this.filters['tipo'].forEach(x => {
          estados = [...estados, ...this.negociosService.getConfirmacionOptionsByTipo()[x.ID].map(o => o.ID)];
        });
        // Sacar las opciones elegidas previamente si es que cambiamos el tipo de negocio y esa opción de Estado ya no está
        // disponible (recordemos que orden tiene menos opciones que intención y los nuevos estados solo tienen Finalizado)
        const tmpConfirmacionIds = this.confirmacionOptions.map(o => o.ID);
        this.filters['confirmación'] = this.filters['confirmación'].filter(o => estados.indexOf(o.ID) >= 0);

        // sacar las opciones no disponibles de la seleccion de estados
        this.confirmacionOptions = this.confirmacionOptions.filter(o => estados.indexOf(o.ID) >= 0);
      }

      // Ahora quitar las opciones del select si es que ya están seleccionadas
      const tmpSelectedIds = this.filters['confirmación'].map(o => o.ID);
      this.confirmacionOptions = this.confirmacionOptions.filter(o => tmpSelectedIds.indexOf(o.ID) < 0);
    } else if (this.column === 'zona') {
      this.checkZonaOptions();
    } else if (this.column === 'tipo') {
      this.tipoOptions = this.tipoOptions.filter(x => this.filters['tipo'].findIndex(y => y.ID === x.ID) < 0);
    }

    // Datetime picker
    /*this.timePickerOptions = {
      icon: '',
      icons: {
        up: 'zmdi zmdi-chevron-up',
        down: 'zmdi zmdi-chevron-down'
      },
      placeholder: 'Hora',
      autoclose: true,
      showMeridian: false
    };

    this.datePickerOptions = {
      placeholder: 'Fecha',
      format: 'dd/mm/yyyy',
      autoclose: true,
      todayHighlight: true,
      language: 'es'
    };*/
  }

  ngAfterViewInit() {
    if (this.column === 'cliente') {
      this.cuentaAutocompleteComponent.selectedCuentas = this.filters['cliente'] ? this.filters['cliente'].slice() : [];
    } else if (this.column === 'responsable') {
      this.colaboradorAutocompleteComponent.selectedColaboradores = this.filters['responsable'] ? this.filters['responsable'].slice() : [];
    } else if (this.column === 'acopio') {
      this.acopioAutocompleteComponent.selectedAcopios = this.filters['acopio'] ? this.filters['acopio'].slice() : [];
    } else if (this.column === 'autorizante') {
      this.colaboradorAutocompleteComponent.selectedColaboradores = this.filters['autorizante'] && this.filters['autorizante'].model2 ? this.filters['autorizante'].model2.slice() : [];
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  showStartDatePicker() {
    this.startDatePicker.open();
  }

  showEndDatePicker() {
    this.endDatePicker.open();
  }

  selectedStartDate(e) {
    if (e > this.filters[this.column].endDate) {
      this.filters[this.column].endDate = e;
    }
  }

  selectedEndDate(e) {
    if (e < this.filters[this.column].startDate) {
      this.filters[this.column].startDate = e;
    }
  }

  changeAutorizante() {
    if (this.filters['autorizante'].model1 !== 'NO-AUTO') {
      this.onSubmit();
    }
  }

  changeConfirmacion() {
    // Opción "Todas"
    if (this.tmpConfirmacion === '') {
      this.filters['confirmación'] = [];
      this.onSubmit();
      return;
    }

    this.filters['confirmación'].push(this.confirmacionOptions.find(o => o.ID === this.tmpConfirmacion));

    this.confirmacionOptions = this.confirmacionOptions.filter(o => o.ID !== this.tmpConfirmacion);
    this.tmpConfirmacion = null;

  }

  removeConfirmacionOption(to) {
    this.filters['confirmación'] = this.filters['confirmación'].filter(o => o.ID !== to.ID);
    this.confirmacionOptions.push(to);
    this.confirmacionOptions.sort((a,b) => a.ID - b.ID);
    this.tmpConfirmacion = undefined;
  }

  changeTipo() {
    // Opción "Todas"
    if (this.tmpTipo === '') {
      this.filters['tipo'] = [];
      this.onSubmit();
      return;
    }

    this.filters['tipo'].push(this.tipoOptions.find(o => o.ID === this.tmpTipo));

    this.tipoOptions = this.tipoOptions.filter(o => o.ID !== this.tmpTipo);
    this.tmpTipo = null;
  }

  removeTipo(to) {
    this.filters['tipo'] = this.filters['tipo'].filter(o => o.ID !== to.ID);
    this.tipoOptions.push(to);
    this.tipoOptions.sort((a, b) => a.ID - b.ID);
    this.tmpTipo = undefined;
  }

  changeCategoria() {
    // Opción "Todas"
    if (this.tmpCategoria === '') {
      this.filters['zona'] = [];
      this.onSubmit();
      return;
    }

    this.filters['zona'].push(this.categoriaOptions.find(o => o.ID === this.tmpCategoria));

    this.categoriaOptions = this.categoriaOptions.filter(o => o.ID !== this.tmpCategoria);
    this.tmpCategoria = null;
  }

  removeCategoriaOption(to) {
    this.filters['zona'] = this.filters['zona'].filter(o => o.ID !== to.ID);
    this.categoriaOptions.push(to);
    this.categoriaOptions.sort((a, b) => a.ID - b.ID);
    this.tmpCategoria = undefined;
  }

  onSubmit() {
    this.errors = false;

    // Opción 'Todos' en selects
    if (((['producto', 'negocio', 'entrega', 'cosecha',
         'moneda', 'match', 'autorizante', 'zona', 'mercado'].indexOf(this.column) >= 0) &&
        (this.filters[this.column].model1 === '')) ||
       (this.column === 'confirmación' && (this.filters['confirmación'].length === 0 || this.confirmacionOptions.length === 0)) ||
       (this.column === 'tipo' && (this.filters['tipo'].length === 0 || this.tipoOptions.length === 0)) ||
       (this.column === 'zona' && (this.filters['zona'].length === 0 || this.categoriaOptions.length === 0)))
    {
      let tmp = Object.assign({}, {...this.filters});
      delete tmp[this.column];
      this.dialogRef.close({
        column: this.column,
        filters: tmp,
        todos: true
      });
      return;
    }

    if (['base', 'tns', 'precio', 'precio-especial'].indexOf(this.column) >= 0) {
      this.errors = (typeof this.filters[this.column].model1 !== 'number' &&
        typeof this.filters[this.column].model2 === 'number') ||
        (typeof this.filters[this.column].model1 === 'number' &&
          typeof this.filters[this.column].model2 !== 'number');
    }
    if (this.column === 'autorizante' && this.filters['autorizante'].model1 === 'NO-AUTO' && !this.colaboradorAutocompleteComponent.selectedColaboradores.length) {
      this.errors = true;
    }
    if (this.errors) {
      return;
    }

    if (this.filters['entrega'] && typeof this.filters['entrega'].model1 === 'number') {
      this.filters['entrega'].model2 = {
        id: this.entregaOptions[this.filters['entrega'].model1].ID,
        idPos: this.entregaOptions[this.filters['entrega'].model1].ID_POS,
        entregaId: this.entregaOptions[this.filters['entrega'].model1].Entrega_Id
      };
    }

    if (this.column === 'cliente') {
      this.filters['cliente'] = this.cuentaAutocompleteComponent.selectedCuentas;
    }
    if (this.column === 'responsable') {
      this.filters['responsable'] = this.colaboradorAutocompleteComponent.selectedColaboradores;
    }
    if (this.column === 'acopio') {
      this.filters['acopio'] = this.acopioAutocompleteComponent.selectedAcopios;
    }
    if (this.column === 'autorizante') {
      this.filters['autorizante'].model2 = this.colaboradorAutocompleteComponent.selectedColaboradores;
    }

    // Value for display in chips
    if (this.column === 'producto') {
      this.filters['producto'].model1Value = this.productoOptions.find(e => e.ID === this.filters['producto'].model1).Producto;
    } else if (this.column === 'negocio') {
      this.filters['negocio'].model1Value = this.negocioOptions.find(e => e.value === this.filters['negocio'].model1).label;
    } else if (this.column === 'entrega') {
      this.filters['entrega'].model1Value = this.entregaOptions[this.filters['entrega'].model1].Entrega || this.entregaOptions[this.filters['entrega'].model1].Posicion;
    } else if (this.column === 'cosecha') {
      this.filters['cosecha'].model1Value = this.cosechaOptions.find(e => e.ID === this.filters['cosecha'].model1).Cosecha;
    } else if (this.column === 'moneda') {
      this.filters['moneda'].model1Value = this.monedaOptions.find(e => e.ID === this.filters['moneda'].model1).Simbolo;
    } else if (this.column === 'mercado') {
      this.filters['mercado'].model1Value = this.mercadosOptions.find(e => e.Id === this.filters['mercado'].model1).Mercado;
    }

    this.dialogRef.close({
      column: this.column,
      filters: this.filters
    });
  }

  checkZonaOptions() {
    if (this.filters['zona']) {
      const tmpSelectedIds = this.filters['zona'].map(o => o.ID);
      this.categoriaOptions = this.categoriaOptions.filter(o => tmpSelectedIds.indexOf(o.ID) < 0);
    }
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/negocios/filters-negocios-dialog.component.ts